<template>
  <div>
    <div class="bg-white w-full flex flex-wrap custom-h border rounded border-gray-500">
      <div class="w-3/4 icon-size text-center mx-auto pt-10" :class="iconColorClass">
        <zt-icon name="cloud-arrow-up" />
      </div>
      <div class="w-3/4 text-zt-lg text-center mx-auto pt-4 underline flex justify-around" :class="textColorClass">
        <p @click="startOpenWindow()" class="cursor-pointer">{{
          $t('message.settingsComponent.list.FileUploadComponent.formComponent.loadImage') }}</p>
        <p class="cursor-pointer" @click="choosePdfFile()">{{
          $t('message.settingsComponent.list.FileUploadComponent.formComponent.loadFIle')
        }}</p>
      </div>
      <div class="w-3/4 flex items-center justify-center mx-auto py-10 custom-font-color">
        <div class="w-1/2 text-center">
          <span>{{ $t("message.FileUploadComponent.formComponent.allowedFiles") }}</span>
          <div class="w-full flex flex-wrap items-center justify-center mt-2">
            <div class="w-10 mx-2 custom-bg-box rounded">
              <span>jpg</span>
            </div>
            <div class="w-10 mx-2 custom-bg-box rounded">
              <span>png</span>
            </div>
          </div>
        </div>
        <div class="w-1/2 text-center">
          <span>{{ $t("message.FileUploadComponent.formComponent.maxFileSize") }}</span>
          <div class="w-full flex flex-wrap items-center justify-center mt-2">
            <div class="w-12 rounded custom-bg-box">
              <span>5 mb</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['state', 'mutations'],
  data() {
    return {}
  },
  props: ['openWindow'],
  computed: {
    isInIframe() {
      return window.self !== window.top
    },
    iconColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200'
    },
    textColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-100'
    }
  },
  methods: {
    setEditMode() {
      this.mutations.setEditMode(true)
    },
    startOpenWindow() {
      this.mutations.setEditMode(true)
      this.openWindow()
    },
    choosePdfFile() {
      let input = document.createElement('input');
      input.type = 'file';
      input.accept = "application/pdf"
      input.onchange = e => {
        let file = e.target.files[0];
        if (file.type === 'application/pdf' && file.size <= 5000000) {
          let renderImage = { 'UrlOnLoad': URL.createObjectURL(file) }
          file = Object.assign(file, renderImage)
          let numberRandom = Math.floor(Math.random() * 10000)
          let mandatoryFile = {
            hash: "",
            name: "Generico",
            alias: "Generico",
            order: 10,
            value: file.name,
            mimeType: file.type,
            mandatory: true,
            file: file
          }
          let newFile = {
            alias: 'Generico Agregado ',
            hash: '',
            mandatory: false,
            mimeType: file.type,
            name: `Generico_Agregado_${numberRandom}`,
            order: numberRandom,
            value: file.name,
            file: file
          }
          if (this.actualImageIndex + 1 <= this.state.metadata.json.min_files) {
            this.mutations.addDocument(mandatoryFile)
            this.$emit('close-loadfile')
          } else {
            this.mutations.addDocument(newFile)
            this.$emit('close-loadfile')
          }
          this.mutations.setActiveOverlay(false)
        } else if (file.type === 'application/pdf' && file.size >= 500000) {
          this.$swal({
            type: "error",
            title: this.$t("message.FileUploadComponent.formComponent.checkSizeOnPdf"),
            showConfirmButton: true,
            confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
          });

        } else {
          this.$swal({
            type: "error",
            title: this.$t("message.FileUploadComponent.formComponent.selectPdf"),
            showConfirmButton: true,
            confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
          });
        }
      }
      this.mutations.setActiveOverlay(false)
      input.click()

    },
  }
}
</script>

<style lang="scss" scoped>
.custom-h {
  min-height: 16rem;
}

.icon-size {
  font-size: 4rem;
}

.custom-font-color {
  color: #5b5b5b;
}

.custom-bg-box {
  background-color: #c8c8c8;
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>